module.exports = __webpack_public_path__ + "static/img/Nick-Dagostino.d5a7a88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nick-Dagostino.jpg
// module id = 3c2t
// module chunks = 0